export const costcoSubdomain = 'costcobrokerage' as const;
